<template>
    <b-col cols="12" v-if="value">
        <div class="report-card">
            <div class="report-header">
                <div class="report-title">Report Summary</div>
                <div class="report-date" style="font-size: 1.1rem;" v-if="filter">
                    <span v-if="filter.FromDate === filter.ToDate">For {{ convertDate(filter.FromDate) }}</span>
                    <span v-else>For {{ convertDate(filter.FromDate) }} - {{ convertDate(filter.ToDate) }}</span>
                </div>
                    <span class="report-created-on" style="font-size: 0.9rem;">
                        Created on: {{ convertDate(new Date(), false) }} - {{ new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true }) }}
                    </span>
                <div class="report-server" v-if="filter">Server: {{ filter.ServerName }}</div>
            </div>

            <div class="report-body">
                <div class="line-item bold">
                    <span>Gross Sales</span>
                    <span>{{ currency(value.Gross_Sale) }}</span>
                </div>

                <div class="line-item sub-item">
                    <span>Less: Credit(Comp & Discount)</span>
                    <span>-{{ currency(value.Credits) }}</span>
                </div>
                <div class="line-item sub-item">
                    <span>Less: Refunds</span>
                    <span>-{{ currency(value.Refunds) }}</span>
                </div>

                <div class="dashed-separator"></div>

                <div class="line-item bold">
                    <span>Net Sales</span>
                    <span>{{ currency(value.Net_Sale) }}</span>
                </div>

                <div class="line-item sub-item">
                    <span>Add: Tax</span>
                    <span>+{{ currencyNoSign(value.Taxes) }}</span>
                </div>
                <div class="line-item sub-item">
                    <span>Add: Tips</span>
                    <span>+{{ currencyNoSign(value.Tips) }}</span>
                </div>

                <div class="dashed-separator"></div>

                <div class="line-item bold">
                    <span>Total Payments Collected</span>
                    <span>{{ currency(value.Paymeny_Received) }}</span>
                </div>
                <div class="payment-breakdown">
                    (Card Pay:{{ currency(value.Paymeny_Received_Card) }} / Cash Pay:{{ currency(value.Paymeny_Received_Cash) }} / Other Pay: {{ currency(value.Paymeny_Received_OtherPaid) }})
                </div>

                <div class="line-item bold mt-3">
                    <span>Number of Orders: {{ value.No_Of_Tabs }}</span>
                </div>
                <div class="line-item bold">
                    <span>Total Cash Collected: {{ currency(value.Paymeny_Received_Cash) }}</span>
                </div>
                <div class="line-item bold">
                    <span>Total Voids: {{ currency(value.Total_Voids != null ? value.Total_Voids : 0) }}</span>
                </div>
                <div class="line-item bold">
                    <span>Average Order Value: {{ currency(averageOrderValue) }}</span>
                </div>
            </div>
        </div>
    </b-col>
</template>

<script>
import moment from 'moment'

export default {
    name: "ReportSummery",
    props: {
        value: {
            type: Object,
            default: null
        },
        filter: {
            type: Object,
            default: null
        }
    },
    computed: {
        averageOrderValue() {
            if (!this.value || !this.value.No_Of_Tabs || this.value.No_Of_Tabs === 0) return 0
            return this.value.Net_Sale / this.value.No_Of_Tabs
        }
    },
    methods: {
        convertDate(date) {
            moment.locale('en')
            return date && moment(date).format('D MMM, YYYY')
        },
        currency(val) {
            if (!val && val !== 0) return '$0.00'
            if (val === 0) return '$0.00'
            return '$' + val.toFixed(2)
        },
        currencyNoSign(val) {
            if (!val && val !== 0) return '0.00'
            if (val === 0) return '0.00'
            return val.toFixed(2)
        }
    }
}
</script>

<style scoped>
.report-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    padding: 1.5rem;
    margin-bottom: 1rem;
}

.report-header {
    text-align: center;
    border-bottom: 2px solid #e0e0e0;
    padding-bottom: 0.75rem;
    margin-bottom: 1rem;
}

.report-title {
    font-size: 1.35rem;
    font-weight: bold;
    color: #222;
}

.report-date {
    font-size: 0.9rem;
    color: #666;
    margin-top: 0.15rem;
}

.report-created-on {
    font-size: 1rem;
    color: #666;
    margin-top: 0.15rem;
}
.report-server {
    font-size: 0.9rem;
    color: #666;
}

.report-body {
    padding: 0 0.25rem;
}

.line-item {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    padding: 0.2rem 0;
    font-size: 0.95rem;
    color: #333;
}

.line-item.bold {
    font-weight: bold;
    font-size: 1rem;
    color: #111;
}

.sub-item {
    padding-left: 1rem;
    font-size: 0.9rem;
    color: #555;
}

.dashed-separator {
    border-bottom: 2px dashed #bbb;
    margin: 0.4rem 0 0.5rem 40%;
}

.payment-breakdown {
    font-size: 0.8rem;
    color: #666;
    text-align: center;
    padding: 0.25rem 0;
}
</style>
